export default "__VITE_ASSET__BBXHHJpJ__"